package com.oratakashi.web.resources

import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.ButtonStyle
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.components.style.addVariantBase
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val NavigationStyle by ButtonStyle.addVariantBase {
    Modifier
        .setVariable(ButtonVars.BackgroundDefaultColor, R.colors.CARD_BACKGROUND_LIGHT.value)
        .setVariable(ButtonVars.BackgroundHoverColor, R.colors.PRIMARY_300.value)
        .padding(leftRight = 20.px)
        .borderRadius(R.dimens.BORDER_RADIUS.px)
        .boxShadow(
            color = R.colors.SHADOW_COLORS.value.toRgb().copy(alpha = 20),
            blurRadius = 60.px,
            spreadRadius = 50.px
        )
        .transition(CSSTransition(property = TransitionProperty.All, duration = 300.ms))
}